import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import { createWallet } from '../../../http/WalletsApi';

const initialForm = Object.freeze({ name: '', portfolioId: '' });

export default function AddWalletDialog({
  open,
  onClose,
  portfolios = [],
  defaultPortfolioId,
  onWalletAdded,
  setErrMessage,
  errMessage,
  setSnackOpen,
}) {
  const [form, setForm] = React.useState(initialForm);

  React.useEffect(() => {
    setForm((prev) => ({
      ...prev,
      portfolioId: defaultPortfolioId || prev.portfolioId,
    }));
  }, [defaultPortfolioId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        name: form.name,
        portfolioId: Number(form.portfolioId),
      };
      const response = await createWallet(payload);
      // response is envelope: { success, status, path, data: { ... } } or similar
      let wallet;
      if (response && response.data && response.data.id) wallet = response.data;
      else if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.id
      )
        wallet = response.data.data;
      else wallet = response;

      onWalletAdded(wallet);
      setForm(initialForm);
      onClose();
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Add wallet</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              name="name"
              label="Name"
              value={form.name}
              onChange={handleChange}
              fullWidth
              required
            />
            <TextField
              select
              name="portfolioId"
              label="Portfolio"
              value={form.portfolioId || ''}
              onChange={handleChange}
              fullWidth
              required
            >
              {portfolios.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.name}
                </MenuItem>
              ))}
            </TextField>
            <Button type="submit" variant="contained">
              Add wallet
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
}
